import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-588113b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading" }
const _hoisted_2 = { class: "loading__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading__bar" }, null, -1))

import { computed, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  setup(__props) {

_useCssVars(_ctx => ({
  "16ffefc4": (_unref(percentage))
}))

const progress = ref(0)
function increasePercentage() {
  if (progress.value < 100) {
    progress.value += 0.2
  } else {
    progress.value = 0
  }
  setTimeout(() => increasePercentage(), 10)
}
const percentage = computed(() => {
  return progress.value + '%'
})

increasePercentage()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('loadingLabel')), 1),
    _hoisted_3
  ]))
}
}

})